import axios from 'axios'

// Création d'une instance Axios avec baseURL
const api = axios.create({
  baseURL: 'http://127.0.0.1:8000/api', // ✅ adapte si ton URL backend est différente
})

// Ajout automatique du token dans les headers
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Fonctions API
export const getReservations = () => api.get('/training-reservations')
export const createReservation = (data) => api.post('/training-reservations', data)
export const updateReservation = (id, data) => api.put(`/training-reservations/${id}`, data)
export const deleteReservation = (id) => api.delete(`/training-reservations/${id}`)
export const updateStatus = (id, status) => api.patch(`/training-reservations/${id}/status/${status}`)
